exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "ng2-ya-table {\n\tmargin-top: 50px;\n\tdisplay: block;\n}\n\ntable.ng2-ya-table .sorting_asc::after {\n\tcontent: \"\\F160\";\n    font: normal normal normal 14px/1 FontAwesome;\n}", ""]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();


//////////////////
// WEBPACK FOOTER
// /Users/danfostersmith/Documents/GitHub/crossing-borders/src/app/dbform/dbform.component.css
// module id = ../../../../../src/app/dbform/dbform.component.css
// module chunks = main